import StoreUtil from '@app/store/StoreUtil';
import { getNotifications } from '@countryCore/models/user/UserDataService';
import { getBalanceWithBonus, isIdCardVerificationPending } from '@core/models/user/UserDataService';
import config from '@config';
import { NotificationType } from '@models/user/enums';
import { IState } from '@app/store';
import UserNotification from '@models/user/notifications/UserNotification';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export interface INotificationsState {
    notifications: UserNotification[];
}

function defaultState(): INotificationsState {
    return {
        notifications: [],
    };
}

export default {
    namespaced: true,

    state: defaultState(),

    mutations: {
        [ADD_NOTIFICATION]: StoreUtil.createPushToListMutator('notifications'),
        [REMOVE_NOTIFICATION](state: INotificationsState, type: NotificationType) {
            const index = state.notifications.findIndex((n) => n.type === type);

            if (index === -1) {
                return;
            }

            state.notifications.splice(index, 1);
        },
    },

    getters: {
        notifications: (state: INotificationsState, getters: any, rootState: IState, rootGetters: any) => {
            const user = rootGetters['data/authentication/user'];

            if (!user) {
                return [];
            }

            const notifications = getNotifications(user);
            const balance = getBalanceWithBonus(user);

            if (balance && balance < config.app.user.lowBalance) {
                notifications.push({
                    title: 'user balance to low',
                    type: NotificationType.lowBalance
                });
            }

            const isIdCardPendingInNotifications = state.notifications
                .find((n: UserNotification) => n.type === NotificationType.idCardVerificationPending);
            if (isIdCardVerificationPending(user) && !isIdCardPendingInNotifications) {
                notifications.push({
                    title: 'Know your user pending',
                    type: NotificationType.idCardVerificationPending
                });
            }

            return [
                ...notifications,
                ...state.notifications,
            ];
        },
    },

    actions: {
        addNotification: StoreUtil.createSimpleMutatorAction(ADD_NOTIFICATION),
        removeNotification: StoreUtil.createSimpleMutatorAction(REMOVE_NOTIFICATION),
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/notifications/notificationsIndex.ts